module.exports = __webpack_public_path__ + "static/media/YF72_0.26c2ad2b.jpg";